(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-food-diets', {
                parent: 'entity',
                url: '/type-food-diets',
                data: {
                    authorities: [],
                    pageTitle: 'TypeFoodDiets'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-food-diets/list/type-food-diets.html',
                        controller: 'TypeFoodDietsController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Food Diet'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS, access);
                }]
            });
    }
})();
